export const queryAllUssPartialView = groq`*[_type == "signupPartialView"]`;
export const queryUssPartialView = groq`*[_type == "signupPartialView" && currentPathname == $currentPathname][0]`;
export const queryUssEmailStatusImage = groq`*[_type == "signupPartialView" && currentPathname == '/en/includes/signup-partials/uss-signup-email-status'][0]{
  "image": signupPartialViewsSectionBuilder.sectionBuilder[0].image.image
}`;
